import { formatRepoFiltersToApiFilters } from '@webapp/core/utils/repositories/formatRepoFiltersToApiFilters'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type ILinkedBankAccountRepository } from '@webapp/platform/banking/business-logic/interfaces/ILinkedBankAccountRepository'
import { type LinkedBankAccountConstructor } from '@webapp/platform/banking/entities/LinkedBankAccount'
import { mapLinkedBankAccountApiModel } from '../../mappers/mapLinkedBankAccountApiModel'
import { type GetLinkedBankAccountsResponse } from '../../types/GetLinkedBankAccountsResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class LinkedBankAccountRepository implements ILinkedBankAccountRepository {
  constructor(private readonly deps: Dependency) {}

  async getLinkedBankAccounts(
    params?: RepoFilterParams
  ): Promise<RepoPaginatedResponse<LinkedBankAccountConstructor>> {
    try {
      const res = await this.deps.httpClient.get<GetLinkedBankAccountsResponse>(
        `/api/v3/payments/linked-bank-accounts/`,
        {
          params: formatRepoFiltersToApiFilters(params),
        }
      )

      const linkedBankAccounts = res.data.data || []
      const metadata = res.data.metadata

      return {
        data: linkedBankAccounts.map((account) =>
          mapLinkedBankAccountApiModel(account)
        ),
        pagination: {
          count: metadata?.pagination?.count || 0,
          page: metadata?.pagination?.current_page || 0,
          pageSize: metadata?.pagination?.page_size || 0,
          numPages: metadata?.pagination?.num_pages || 0,
        },
      }
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }
}
